function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.8654 3.42614H6.94757V4.50832H5.8654V3.42614ZM5.8654 5.59049H6.94757V8.83702H5.8654V5.59049ZM6.40649 0.720703C3.41968 0.720703 0.995605 3.14478 0.995605 6.13158C0.995605 9.11839 3.41968 11.5425 6.40649 11.5425C9.39329 11.5425 11.8174 9.11839 11.8174 6.13158C11.8174 3.14478 9.39329 0.720703 6.40649 0.720703ZM6.40649 10.4603C4.02029 10.4603 2.07778 8.51778 2.07778 6.13158C2.07778 3.74539 4.02029 1.80288 6.40649 1.80288C8.79268 1.80288 10.7352 3.74539 10.7352 6.13158C10.7352 8.51778 8.79268 10.4603 6.40649 10.4603Z",
  fill: "white"
});

function SvgIconInfoOutlineStraight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoOutlineStraight);
export default __webpack_public_path__ + "static/media/icon-info-outline-straight.c512c2c2.svg";
export { ForwardRef as ReactComponent };